var plugin_rtlignore_default = {
  "alignLeft": "rXs1H",
  "textWrapNowrap": "s7-ph",
  "alignRight": "uLijO",
  "alignCenter": "Dnzl4",
  "sizeFullWidth": "gUuzy",
  "renderedInTable": "biOWz",
  "sizeOriginal": "PytaF",
  "sizeContent": "wt-ag",
  "sizeSmall": "NjU0P",
  "sizeSmallCenter": "_4HKVC",
  "flex": "hEYS-",
  "atomic": "_54s8v",
  "embed": "_8zI0C",
  "horizontalScrollbar": "EGBGg",
  "pluginContainerMobile": "_7FpdE"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
